"use client";

import type { VideoSubject } from "@/lib/live/video/video-types";

/**
 * Ce que filme une caméra : des mains, ou un visage.
 *
 * Le même choix en direct, dans la barre de cadrage, et au replay, sur la
 * vignette mise en avant : c'est la même donnée — la table de la séance, que
 * l'enregistrement garde —, et elle se décide devant l'image qu'elle décrit.
 */
export function SubjectChoice({
  subject,
  onChoose,
}: {
  readonly subject: VideoSubject;
  readonly onChoose: (subject: VideoSubject) => void;
}) {
  return (
    <span role="group" aria-label="Ce que filme cette caméra" className="flex items-center gap-1.5">
      <Choice chosen={subject === "hands"} onClick={() => onChoose("hands")}>
        Mains
      </Choice>

      <Choice chosen={subject === "face"} onClick={() => onChoose("face")}>
        Visage
      </Choice>
    </span>
  );
}

function Choice({
  chosen,
  onClick,
  children,
}: {
  readonly chosen: boolean;
  readonly onClick: () => void;
  readonly children: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={chosen}
      className="rounded-md px-2 py-1 text-[11px] transition-colors focus:outline-none focus-visible:ring-2"
      style={{
        color: chosen ? "#ffffff" : "var(--color-text-secondary)",
        background: chosen ? "var(--color-accent)" : "rgba(255, 255, 255, 0.08)",
        cursor: "pointer",
        ["--tw-ring-color" as string]: "var(--color-accent)",
      }}
    >
      {children}
    </button>
  );
}
